'use strict';

var React = require('react');

var SvgPaintBrushMajor = function SvgPaintBrushMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20 18c0-.79-1.018-2.488-1.601-3.397a.47.47 0 0 0-.798 0c-.583.909-1.601 2.607-1.601 3.397 0 1.107.893 2 2 2s2-.893 2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11 0-5.518 5.5 9.018 9.018 5.5-5.518-5-5-3 1 1-3-2-2zm-7.512 7.488.5-.498 9.022 9.023-.538.541c-.575.575-1.493.569-2.173.124-1.053-.69-2.146-1.132-3.248-.913a4.72 4.72 0 0 0-.378.092c-.506.145-.93.477-1.301.85-.374.374-.656.848-.937 1.321-.383.643-.763 1.284-1.373 1.667a2 2 0 0 1-2.77-2.738c.383-.624 1.035-1.012 1.69-1.402.475-.283.952-.567 1.328-.943.398-.399.753-.855.89-1.402l.02-.08c.27-1.143-.134-2.351-.858-3.466-.443-.681-.45-1.6.126-2.176z"
  }));
};

exports.SvgPaintBrushMajor = SvgPaintBrushMajor;
